import { useEffect } from "react"
import lottieJson from "./animations/homepage.json"

export default function HomepageLottieAnimation() {
  useEffect(() => {
    window.lottie.loadAnimation({
      container: document.querySelector("#homepage-animation"), // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: lottieJson, // the path to the animation json
    })
  })

  return <div id="homepage-animation"></div>
}
